import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()(() => ({
  datesContainer: {
    padding: '16px 16px 16px 16px',
    backgroundColor: '#F6F6F8',
    marginTop: 16,
  },
  dialogContent: {
    padding: 0,
  },
  dialogActions: {
    padding: '8px 0 8px 0',
  },
  spacing: {
    marginTop: 16,
  },
}));
